import { AuthApi, Configuration, NotificationDto, UpsertNotificationSubscriptionDto } from '@inosio/payments-sdk';
import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { IpaUserExtended, selectCurrentUser } from '../../sagas/auth/authSlice';
import {
  getSupportedNotifications,
  createNotificationSubscription,
  setSupportedNotificationsError,
  setCreateNotificationSubscription,
  setSupportedNotificationsData,
  setCreateNotificationSubscriptionError,
  deleteNotificationSubscription,
  setDeleteNotificationSubscription,
  setDeleteNotificationSubscriptionError,
} from './notificationSettingSlice';

const { REACT_APP_IPA_BASE_PATH } = process.env;

export function requestGetSupportedNotifications(access_token: string) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken: access_token,
  });

  const ipaAuthApi = new AuthApi(apiConfig);
  return ipaAuthApi.fetchSupportedNotifications();
}
export function requestCreateNotificationSubscription(access_token: string,updateReportSubscriptionDto: UpsertNotificationSubscriptionDto) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken: access_token,
  });

  const ipaAuthApi = new AuthApi(apiConfig);
  return ipaAuthApi.createOrUpdateNotificationSubscription(updateReportSubscriptionDto);
}

export function requestDeleteNotificationSubscription(access_token: string, notificationId: string) {
  const apiConfig = new Configuration({
    basePath: REACT_APP_IPA_BASE_PATH,
    accessToken: access_token,
  });

  const ipaAuthApi = new AuthApi(apiConfig);
  return ipaAuthApi.deleteNotificationSubscription(notificationId);
}

export function* handleGetSupportedNotifications(action: { type: typeof getSupportedNotifications }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    const response: AxiosResponse<NotificationDto[]> = yield call(requestGetSupportedNotifications, currentUser.accessToken);

    const { data } = response;
    yield put(setSupportedNotificationsData(data));
  } catch (error: any) {
    yield put(setSupportedNotificationsError({ ...error?.response?.data }));
  }
}
export function* handleCreateNotificationSubscription(action: { type: typeof createNotificationSubscription; payload: UpsertNotificationSubscriptionDto }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestCreateNotificationSubscription, currentUser.accessToken, action.payload);

    yield put(setCreateNotificationSubscription());
  } catch (error: any) {
    yield put(setCreateNotificationSubscriptionError({ ...error?.response?.data }));
  }
}

export function* handleDeleteNotificationSubscription(action: { type: typeof deleteNotificationSubscription; payload: { notificationId: string } }) {
  try {
    const currentUser:IpaUserExtended= yield select(selectCurrentUser);
    yield call(requestDeleteNotificationSubscription, currentUser.accessToken,action.payload.notificationId);

    yield put(setDeleteNotificationSubscription());
  } catch (error: any) {
    yield put(setDeleteNotificationSubscriptionError({ ...error?.response?.data }));
  }
}

export default function* reportsSaga() {
  yield takeLatest(getSupportedNotifications.type, handleGetSupportedNotifications);
  yield takeLatest(createNotificationSubscription.type, handleCreateNotificationSubscription);
  yield takeLatest(deleteNotificationSubscription.type, handleDeleteNotificationSubscription);
}
